import React from 'react';
import { createUseStyles } from 'react-jss';

import classnames from 'classnames';
import { Trans } from 'react-i18next';

import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  label: {
    ...theme.fonts.label,
    color: theme.colors.inkSecondary,
  },
  oneLine: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
  },
  iconCheck: {
    fontSize: theme.iconSize.regular,
    color: theme.colors.greenAccessible,
  },
  iconClose: {
    fontSize: theme.iconSize.regular,
    color: theme.colors.redAccessible,
  },
}));

interface Props {
  verified?: boolean;
  label: string;
}

export const LabelWithVerifiedIcon = ({ label, verified }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.oneLine}>
      <div className={classes.label}>{label}</div>
      {verified && (
        <i
          className={classnames('ri-checkbox-circle-fill', classes.iconCheck)}
        />
      )}
    </div>
  );
};
